import _isEqual from 'lodash/isEqual';
import { useEffect, useState, useLayoutEffect } from 'react';

/**
 * Retorna o mesmo valor anterior, se o novo valor for igual. Não é imediato - a comparação
 * é feita após o render (usando useEffect)
 * @param value
 * @param isEqual
 * @returns
 */
export default function usePreviousIfEquals<V>(value: V, isEqual: typeof _isEqual = _isEqual, whenCompare: 'USE_EFFECT' | 'USE_LAYOUT_EFFECT' = 'USE_EFFECT'): V {
  const [prev, setPrev] = useState(() => value);
  useEffect(() => {
    if (whenCompare == 'USE_EFFECT') setPrev(prev => {
      if (prev !== value && !isEqual(value, prev)) {
        return value;
      }
      return prev;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  useLayoutEffect(() => {
    if (whenCompare == 'USE_LAYOUT_EFFECT') setPrev(prev => {
      if (prev !== value && !isEqual(value, prev)) {
        return value;
      }
      return prev;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return prev;
}